import type { ReactNode } from 'react';

export const symbol_mobile_hand_left_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m800-251-60-60v-509H342v111l-60-60v-51q0-24.75 17.63-42.38Q317.25-880 342-880h398q24.75 0 42.38 17.62Q800-844.75 800-820v569Zm60 186.39q-9 8.61-21.36 9.11Q826.27-55 817-64l-34-34q-8 8-19.08 13-11.09 5-23.92 5H398l50-60h293L581-300 394-76q-15 18-36.5 27T313-40h-43q-63 0-106.5-43.5T120-190v-330q0-49 28-87t72-54L52-829q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l765 765q9 9 9 21t-9 21.39ZM541-566Zm21.5-122.68q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM741-140Zm-471 40h42q11 0 21.5-4.5T351-118l152-183-221 100v-398l-12-11q-38 0-64 26t-26 64v330q0 37 26 63.5t64 26.5Zm72-199 171-69-171-171v240Z"
		/>
	</svg>
);
